import {Announcement} from '@shopify/marketing-assets';

import {UiIllustrations} from '../components/ui-illustrations';
import DemoVideo from '../components/demo-video';
import WistiaModal from '../modules/wistia-modal';
import {TransparentNav} from '../modules/transparent-nav';
import InteractiveMap from '../components/interactive-map';
import '../application';

new UiIllustrations();

function init() {
  const announcement = document.querySelector('.js-announcement');
  if (announcement) {
    new Announcement(announcement); // eslint-disable-line no-new
  }

  TransparentNav(document.querySelector('.homepage-hero'));

  document.querySelectorAll('.pillars-animation').forEach((elem) => {
    new DemoVideo(elem); // eslint-disable-line no-new
  });

  document.querySelectorAll('.js-wistia-modal').forEach(($el) => new WistiaModal($el));

  initMap();
}

function initMap() {
  const sectionContainer = document.querySelector('.map-interactive');
  const mapContainer = document.querySelector('.map__container');
  const map = new InteractiveMap(mapContainer, sectionContainer);
  map.init();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
